// @flow
/* eslint-disable react/no-danger */
import React from 'react';

const icon = {
    __html: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                <path fill="#999" fill-rule="evenodd" d="M16 11v.667a.332.332 0 0 1-.333.333H9.259c-.796-.26-1.11-.556-1.11-.556S9.332 9.648 9.332 7c0-1.926-1.277-3.056-1.277-3.056v-.018A7.32 7.32 0 0 1 8 3a3 3 0 0 1 3-3c1.648 0 3 1.352 3 3 0 2.76-1.333 4.26-1.333 4.26C12.667 9.332 16 8.666 16 11zm-6 4v.667a.332.332 0 0 1-.333.333H.333A.332.332 0 0 1 0 15.667V15c0-2.315 3.333-1.667 3.333-3.74C3.333 11.26 2 9.76 2 7a3 3 0 0 1 3-3c1.648 0 3 1.352 3 3 0 2.76-1.333 4.26-1.333 4.26C6.667 13.332 10 12.666 10 15z"/>
            </svg>
            `
};

export const IconUsers = () => <span dangerouslySetInnerHTML={icon} />;

export default IconUsers;
